import axios, { AxiosInstance } from 'axios';

export type HttpHeaders = {
  [key: string]: string;
}

export type RequestConfig = {
  headers: HttpHeaders;
}

export class APIConfiguration {
  accessToken?: string;
}

let host = "http://localhost:8005";
if(window.location.hostname != "localhost"){
  host = "https://gsdemoapi.dgen.solutions";
}
const client: AxiosInstance = axios.create({
  baseURL: host + '/api/static/api.gaming-stars.net/api/v0',
  timeout: 10000,
  responseType: 'json' as const,
  headers: {
    'Content-Type': 'application/json',
    // 'User-Agent': 'Gaming Stars/1.6.5 (com.owlab.gaming-stars; build:1; iOS 16.0.0) Alamofire/1.6.5',
    // 'platform': 'ios',
  }
});

client.interceptors.request.use((config) => {
  // @ts-ignore
  config.headers.Authorization = `token ${ window.localStorage.getItem('token') }`;
  return config;
});

export async function getRequest<TResponse>(path: string, params?: Object): Promise<TResponse> {
  try {
    const response = await client.get<TResponse>(path, params);

    if(response.status !== 200) {
      handleServiceError(response);
      return { } as TResponse;
    }
    return response.data;
  } catch (error) {
    handleServiceError(error);
  }

  return { } as TResponse;
}

export async function postRequest<TResponse>(path: string, body: object = {}): Promise<TResponse> {
  try {
    const response = await client.post<TResponse>(path, body);

    return response.data;
  } catch (error) {
    handleServiceError(error);
  }

  return { } as TResponse;
}

export async function patchRequest<TResponse>(path: string, body: object = {}): Promise<TResponse> {
  try {
    const response = await client.patch<TResponse>(path, body);

    return response.data;
  } catch (error) {
    handleServiceError(error);
  }

  return { } as TResponse;
}

export async function deleteRequest<TResponse>(path: string, params?: Object): Promise<TResponse> {
  try {
    const response = await client.delete<TResponse>(path, params);

    return response.data;
  } catch (error) {
    handleServiceError(error);
  }

  return { } as TResponse;
}

export async function searchRequest<TResponse>(path: string, query: string): Promise<TResponse> {
  try {
    const response = await client.get<TResponse>(path, { params: { query }});

    return response.data;
  } catch (error) {
    handleServiceError(error);
  }

  return { } as TResponse;
}

export interface ClientInterface {
  get<TResponse>(path: string, params?: Object): Promise<TResponse>;
  post<TRequest, TResponse>(path: string, object: TRequest, config?: RequestConfig): Promise<TResponse>;
  patch<TRequest, TResponse>(path: string, object: TRequest): Promise<TResponse>;
  put<TRequest, TResponse>(path: string, object: TRequest): Promise<TResponse>;
  delete <TResponse>(path: string): Promise<TResponse>;
  search<TResponse>(path: string, query: string): Promise<TResponse>;
}

function handleServiceError(error: any) {
  console.error(error);
  console.log('handleServiceError() error', error);
  console.log('handleServiceError() error.response', error.response);
  if (error.response.status === 401 || error.response.status === 403) {
    console.log('Unauthorized - redirecting to login!');
    localStorage.removeItem('token');
    /// Go to login
    document.location.reload();
  }
}

// const axiosMiddlewareOptions = {
//   interceptors: {
//     request: [
//       (action, config) => {
//         if (localStorage.token || localStorage.token_res) {
//           let token = localStorage.token ? localStorage.token : localStorage.token_res;
//           config.headers["Authorization"] = "Token " + token;
//         }
//         if (localStorage.language) {
//           config.headers["Accept-Language"] = localStorage.language;
//         }
//         return config;
//       }
//     ],
//     response: [
//       {
//         success: ({ dispatch }, response) => {
//           return response;
//         },
//         error: ({ dispatch }, error) => {
//           if (error.response.status === 401) {
//             localStorage.removeItem("token");
//             document.location.reload();
//           }
//           return Promise.reject(error);
//         }
//       }
//     ]
//   }
// };


// instance.interceptors.request
//   .use(function (config) {
//     console.log('before request', config);
//     return config;
//   }, function (error) {
//   console.log('on error request', error);
//   return Promise.reject(error);
// });
